import { BODForm } from '@/modules/Dayoffs/components/Form/BODApproveForm'
import { DayOffResponse } from '@/modules/Dayoffs/types/response'
import { ModalProps } from '@/types/shared'
import { Dialog } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'

export interface BomConfirmModalProps extends ModalProps {
    dayOff: DayOffResponse
    refetch: () => void
}

const BomConfirmModal: React.FC<BomConfirmModalProps> = ({
    onClose,
    open,
    dayOff,
    refetch,
}) => {
    const { t } = useTranslation('dayoffs')
    return (
        <Dialog onClose={onClose} open={open} title={t('bod_confirm')}>
            <BODForm dayOff={dayOff} refetch={refetch} onClose={onClose} />
        </Dialog>
    )
}

export default BomConfirmModal
